/* global rp$, document, window */
var THE_SCRIPT = function () {
	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductDetailsModule() {
		const ITEMS_TO_SHOW = 5;

		rp$(document).on('setProductDetails:html', function HandleNewProductDetailsHtml(evt, html) {
			rp$('.product-details-module').html(html);
		});

		function showMoreIncludeProduct(element){
			element.find('.component-listing:hidden').show();
			element.find('.show-more-component').hide();
			element.find('.show-less-component').show();
		}
	
		function showLessIncludeProduct(element){
			element.find('.component-listing:gt(' + (ITEMS_TO_SHOW - 1) + ')').hide();
			element.find('.show-more-component').show();
			element.find('.show-less-component').hide();
		}
		
		function loadIncludeParts() {
			const reqPartsModule = rp$('.required-parts');
			
			reqPartsModule.find('.component-listing').slice(ITEMS_TO_SHOW).hide();

			if (reqPartsModule.find('.component-listing').length < ITEMS_TO_SHOW) {
				reqPartsModule.find('.show-more-component').hide();
			}

			reqPartsModule.find('.show-more-component').on(
				'click', 
				() => {
					showMoreIncludeProduct(reqPartsModule);
				}
			);

			reqPartsModule.find('.show-less-component').on(
				'click', 
				() => {
					showLessIncludeProduct(reqPartsModule);
				}
			);
		}

		loadIncludeParts();
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
